module.exports = __webpack_public_path__ + "static/font-6f69fa9165299a297556e9945a2a3720.woff";